import useGetReviews from './useGetReviews'

export default useGetReviews
